import { Group, Stack } from "@mantine/core"

import { CustomFieldComponentRow } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldComponentRow"
import { CustomFieldTreeBranch } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldTreeBranch"
import { HorizontalDivider, VerticalDivider } from "~/pages/Brand/Products/Details/CustomFieldGraph/Divider.tsx"
import type { CustomFieldTreeSectionProps } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import {
  getProductActivityIds,
  getProductLevelCustomFieldDefinitions,
  getSortedComponents,
  getVerticalDividerCoveredCardsCount,
} from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.utils"

export const CustomFieldProductTree = ({
  product,
  getOperations,
  originCue,
}: CustomFieldTreeSectionProps) => {
  const productItem = product.item
  const productActivityIds = getProductActivityIds(product)
  const sortedComponents = getSortedComponents(product)
  const verticalDividerCoveredCardsCount = getVerticalDividerCoveredCardsCount(
    product,
    sortedComponents
  )

  return (
    <Group
      gap={0}
      align="flex-start"
      style={{ position: "relative" }}
      wrap="nowrap"
    >
      <CustomFieldTreeBranch
        customFieldsDefs={getProductLevelCustomFieldDefinitions(
          product,
          productActivityIds
        )}
        hideFirstDivider={true}
        item={productItem}
        operations={getOperations(productItem)}
        originCue={originCue}
      />
      {product.components.length > 0 && <HorizontalDivider />}
      <Stack align="flex-start" justify="left">
        {product.components.length > 1 && (
          <VerticalDivider itemCount={verticalDividerCoveredCardsCount} />
        )}
        {sortedComponents.map((component) => (
          <CustomFieldComponentRow
            key={component.id}
            component={component}
            product={product}
            productActivityIds={productActivityIds}
            getOperations={getOperations}
          />
        ))}
      </Stack>
    </Group>
  )
}
